export enum LessonViewMode {
  All = 'ALL',
  Section = 'SECTION',
  Gadget = 'GADGET',
}
